(() => {
  'use strict';

  const root = document.documentElement;
  if (root.hasAttribute('data-cfm-cart-modal-init')) {
    return;
  }
  root.setAttribute('data-cfm-cart-modal-init', 'true');

  const state = {
    lastFocusedElement: null,
    cart: null
  };

  const elements = {
    modal: document.querySelector('[data-cart-modal]'),
    panel: document.querySelector('.cfm-cart-modal__panel'),
    loading: document.querySelector('[data-cart-loading]'),
    error: document.querySelector('[data-cart-error]'),
    items: document.querySelector('[data-cart-items]'),
    empty: document.querySelector('[data-cart-empty]'),
    total: document.querySelector('[data-cart-total]')
  };

  if (!elements.modal || !elements.panel || !elements.items || !elements.total) {
    return;
  }

  const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  const isMobileViewport = () => mobileMediaQuery.matches;

  const escapeHtml = (value) => {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const formatMoney = (amount, currency) => {
    const safeAmount = Number(amount) || 0;
    const safeCurrency = currency || 'JPY';
    const normalizedAmount = safeAmount / 100;

    if (safeCurrency === 'JPY') {
      return `${Math.round(normalizedAmount).toLocaleString('ja-JP')}円`;
    }

    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: safeCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(normalizedAmount);
  };

  const setLoading = (isLoading) => {
    if (!elements.loading) {
      return;
    }

    elements.loading.hidden = !isLoading;
  };

  const setError = (message) => {
    if (!elements.error) {
      return;
    }

    const hasMessage = Boolean(message);
    elements.error.hidden = !hasMessage;
    elements.error.textContent = hasMessage ? message : '';
  };

  const updateCount = (count) => {
    const safeCount = Number(count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(safeCount);
      node.hidden = safeCount === 0;
    });
  };

  const getCurrentDisplayedCount = () => {
    const countNode = document.querySelector('[data-cart-count]');
    if (!countNode) {
      return 0;
    }

    return Number(countNode.textContent) || 0;
  };

  const getVariantIdFromTrigger = (trigger) => {
    const variantIdFromData = Number(trigger.getAttribute('data-variant-id'));
    if (variantIdFromData) {
      return variantIdFromData;
    }

    const form = trigger.closest('form[action*="/cart/add"]');
    if (!form) {
      return 0;
    }

    const idField = form.querySelector('input[name="id"], select[name="id"]');
    return Number(idField && idField.value);
  };

  const getQuantityFromTrigger = (trigger) => {
    const quantityFromData = Number(trigger.getAttribute('data-quantity'));
    if (Number.isFinite(quantityFromData) && quantityFromData > 0) {
      return Math.max(1, quantityFromData);
    }

    const form = trigger.closest('form[action*="/cart/add"]');
    if (form) {
      const quantityField = form.querySelector('input[name="quantity"]');
      const quantityFromForm = Number(quantityField && quantityField.value);
      if (Number.isFinite(quantityFromForm) && quantityFromForm > 0) {
        return Math.max(1, quantityFromForm);
      }
    }

    return 1;
  };

  const renderItems = (cart) => {
    const itemList = Array.isArray(cart.items) ? cart.items : [];

    if (itemList.length === 0) {
      elements.items.innerHTML = '';
      if (elements.empty) {
        elements.empty.hidden = false;
      }
      return;
    }

    if (elements.empty) {
      elements.empty.hidden = true;
    }

    const html = itemList
      .map((item) => {
        const title = escapeHtml(item.product_title || item.title || '');
       const url = escapeHtml(item.url || '#');
const imageContent = item.image
  ? `<img class="cfm-cart-modal__thumb" src="${escapeHtml(item.image)}" alt="${title}" loading="lazy">`
  : '<div class="cfm-cart-modal__thumb" aria-hidden="true"></div>';
const image = `<a href="${url}" class="cfm-cart-modal__thumb-link">${imageContent}</a>`;

        const quantity = Number(item.quantity) || 0;
        const linePrice = formatMoney(item.final_line_price, cart.currency);
        const itemKey = escapeHtml(item.key || '');

        return `
          <li class="cfm-cart-modal__item">
            ${image}
            <div>
              <p class="cfm-cart-modal__name">${title}</p>
              <p class="cfm-cart-modal__meta">数量: ${quantity}</p>
              <p class="cfm-cart-modal__meta">小計: ${linePrice}</p>
            </div>
            <button type="button" class="cfm-cart-modal__remove" data-cart-remove="${itemKey}">削除</button>
          </li>
        `;
      })
      .join('');

    elements.items.innerHTML = `<ul class="cfm-cart-modal__list">${html}</ul>`;
  };

  const renderCart = (cart) => {
    state.cart = cart;
    updateCount(cart.item_count);
    elements.total.textContent = formatMoney(cart.total_price, cart.currency);
    renderItems(cart);
    document.dispatchEvent(new CustomEvent('cfm:cart-updated', { detail: { cart } }));
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('カート情報の取得に失敗しました。');
    }

    return response.json();
  };

  const refreshCart = async () => {
    setError('');
    setLoading(true);

    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      setError(error.message || 'カート情報の取得に失敗しました。');
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const isModalOpen = () => !elements.modal.hidden;

  const openModal = () => {
    state.lastFocusedElement = document.activeElement;
    elements.modal.hidden = false;
    elements.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cfm-modal-open');
    elements.panel.focus();
  };

  const closeModal = () => {
    if (!isModalOpen()) {
      return;
    }

    elements.modal.hidden = true;
    elements.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cfm-modal-open');

    if (state.lastFocusedElement && typeof state.lastFocusedElement.focus === 'function') {
      state.lastFocusedElement.focus();
      return;
    }

    const fallback = document.querySelector('[data-cart-open]');
    if (fallback) {
      fallback.focus();
    }
  };

  const addToCart = async (variantId, quantity) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity
      })
    });

    if (!response.ok) {
      const errorJson = await response.json().catch(() => ({}));
      const description = errorJson.description || '商品追加に失敗しました。';
      throw new Error(description);
    }

    return response.json();
  };

  const removeFromCart = async (itemKey) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error('商品の削除に失敗しました。');
    }

    return response.json();
  };

  document.addEventListener('click', async (event) => {
    if (!isMobileViewport()) {
      return;
    }

    const openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      try {
        await refreshCart();
      } catch (error) {
        // Error message is already shown in modal.
      }
      openModal();
      return;
    }

    const closeTrigger = event.target.closest('[data-cart-close], [data-cart-close-btn]');
    if (closeTrigger) {
      event.preventDefault();
      closeModal();
      return;
    }

    const removeTrigger = event.target.closest('[data-cart-remove]');
    if (removeTrigger) {
      event.preventDefault();
      const itemKey = removeTrigger.getAttribute('data-cart-remove');
      if (!itemKey) {
        return;
      }

      removeTrigger.disabled = true;
      setError('');

      try {
        await removeFromCart(itemKey);
        await refreshCart();
      } catch (error) {
        setError(error.message || '商品の削除に失敗しました。');
      } finally {
        removeTrigger.disabled = false;
      }
      return;
    }

    const addTrigger = event.target.closest(
      '[data-add-to-cart], .add-cart-btn-js, form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]'
    );
    if (!addTrigger) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const variantId = getVariantIdFromTrigger(addTrigger);
    if (!variantId) {
      setError('バリアントIDが見つかりません。');
      return;
    }

    const quantity = getQuantityFromTrigger(addTrigger);
    const previousCount = Number(state.cart && state.cart.item_count);
    const baseCount = Number.isFinite(previousCount) ? previousCount : getCurrentDisplayedCount();
    const optimisticCount = baseCount + quantity;

    addTrigger.setAttribute('aria-busy', 'true');
    addTrigger.style.pointerEvents = 'none';
    setError('');
    updateCount(optimisticCount);

    try {
      await addToCart(variantId, quantity);
    } catch (error) {
      updateCount(baseCount);
      setError(error.message || '商品追加に失敗しました。');
      return;
    }

    let cart = null;
    try {
      cart = await refreshCart();
    } catch (error) {
      setError('商品は追加されましたが、カート情報の更新に失敗しました。');
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      }
    } finally {
      addTrigger.removeAttribute('aria-busy');
      addTrigger.style.pointerEvents = '';
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!isMobileViewport()) {
      return;
    }

    if (event.key === 'Escape' && isModalOpen()) {
      closeModal();
    }
  });

  const handleViewportChange = () => {
    if (!isMobileViewport()) {
      closeModal();
      setError('');
      setLoading(false);
      return;
    }

    refreshCart().catch(() => {
      // Initial load error is displayed only when modal is opened.
    });
  };

  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', handleViewportChange);
  } else if (typeof mobileMediaQuery.addListener === 'function') {
    mobileMediaQuery.addListener(handleViewportChange);
  }

  handleViewportChange();
})();
